export function setPermissions(data) {
  return {
    type: 'SET_PERMISSIONS',
    payload: data,
  };
};